import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16ea4444"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid colored-block ps-4" }
const _hoisted_2 = { class: "navbar navbar-expand-sm navbar-dark -" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "./"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "otcpro-logo",
    src: "https://otcpro.com/wp-content/uploads/2021/12/OTCPro3.png",
    alt: "OTC Pro"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarNavDropdown",
  "aria-controls": "navbarNavDropdown",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  id: "navbarNavDropdown",
  class: "navbar-collapse collapse ms-5 justify-content-end"
}
const _hoisted_6 = { class: "navbar-nav ml-auto" }
const _hoisted_7 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Install")
const _hoisted_9 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Manage Subscription")
const _hoisted_11 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Account Profile")
const _hoisted_13 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_ctx.user?.profile?.activationState === 'activated')
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/dashboard/downloads"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.user?.profile?.activationState === 'activated')
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/dashboard/subscription"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.user?.profile?.activationState === 'activated')
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/dashboard/profile"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "/#",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, "Logout")
          ])
        ])
      ])
    ])
  ]))
}